// extracted by mini-css-extract-plugin
export default {"questionGroupWrapper":"QuestionGroup_questionGroupWrapper__4G+sR"};